import { render } from "./logo-color.vue?vue&type=template&id=095212fc"
import script from "./logo-color.vue?vue&type=script&lang=js"
export * from "./logo-color.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__